import { Contactable } from './contactable';

export class User implements Contactable {
  userId: string;
  unifiedUserId?: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  phoneNumber: string;
  createdDateTime: string;
  accountGroupAssociations: string[];
  accountAccessPermissions: { [key: string]: string[] };
  accountTabPermissions: { [key: string]: string[] };
  businessCenterTabs: { [key: string]: string[] };
  notificationsEnabled: boolean;
  accountGroupAssociationCount: number;
  daysActive: number;

  constructor(data: any) {
    // Convert the list of account permissions per account group to a map by account group id
    if (data.accountAccessPermissions) {
      data.accountAccessPermissions = data.accountAccessPermissions.reduce((o, p) => {
        o[p.accountGroupId] = p.accountIds;
        return o;
      }, {});
    }
    if (data.businessCenterTabs) {
      data.accountTabPermissions = data.businessCenterTabs || {};
    } else if (data.accountTabPermissions) {
      data.accountTabPermissions = data.accountTabPermissions.reduce((o, p) => {
        o[p.accountGroupId] = p.tabIds;
        return o;
      }, {});
    }
    Object.assign(this, data);
  }

  // TODO: This should support localization (e.g. some places use lastname firstname format).
  get name(): string {
    return `${this.firstName || ''} ${this.lastName || ''}`.trim();
  }

  // TODO: This should support localization (e.g. some places use lastname firstname format).
  get fullName(): string {
    const fullName = `${this.firstName || ''} ${this.lastName || ''}`;
    return fullName.trim();
  }

  // TODO: This should support localization (e.g. some places use lastname firstname format).
  get descriptiveName(): string {
    return `${this.firstName || ''} ${this.lastName || ''} (${this.email})`.trim();
  }
}
